import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Usecartcontaxt } from './component/cartcontaxt/cart_contaxt'
import Formatprice from './component/Helper/Formatprice';
import { BASE_URL } from './Config/Config';
import SubLoading from './ALL CSS/Loading';
import { useGoogleLogin } from '@react-oauth/google';
import { UseGlobellogin } from './component/Logincontaxt.jsx/Logincontex';
import Loader from './Loader/Loader';

function Cartpage() {
  const { removeitem, SetDecrease , SetIncrease , clearCart  , order_total , databasecartdata , cartloading , totalCartPrice , loading }= Usecartcontaxt();
  const {userId} = UseGlobellogin()
  const User_id = localStorage.getItem("user_id");


          const [bannerData , setBannerImage] = useState([]);
          const [bannerLoading , setBannerLoading] = useState(true);
        
          useEffect(() => {
            const fetchBannerImage = async () => {
              try {
                setBannerLoading(true);
                const response = await fetch(`${BASE_URL}/banner/?page=cartpage`);
                const result = await response.json();
                setBannerImage(result.data[0]);
                    } catch (error) {
                      console.error('Error fetching banner:', error);
                    } finally {
                      setBannerLoading(false);
                    }
                  };
                  
                  fetchBannerImage();
                }, []);






  return (
    <>

    
{
      bannerLoading && bannerData && bannerData.image ? (
        <SubLoading/>
      ):(
   <div className="breadcumb-wrapper"

style={{
       backgroundImage: `url(${BASE_URL}${bannerData.image})`,
       backgroundSize: 'contain',
       backgroundPosition: 'center',
       height:"50px"
     }}      
      data-overlay="title" data-opacity={8}>

  <div className="breadcumb-shape" data-bg-src="assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Cart Page</h1>
      <ul className="breadcumb-menu">
        <li><NavLink to="/">Home</NavLink></li>
        <li>Cart Page</li>
      </ul>
    </div>
  </div>
</div>
      )}


<div className="th-cart-wrapper  space-top space-extra-bottom">
  <div className="container">
       {databasecartdata?.length === 0 ? (
            <div className="empty-cart-message text-center">
              <h2>Your cart is empty</h2>
              <p>Looks like you haven't added anything to your cart yet.</p>
              <NavLink to="/course" className="th-btn">Continue Shopping</NavLink>
            </div>
          ) : ( <>

       <div className="woocommerce-notices-wrapper">
      <div className="woocommerce-message">Shipping costs updated.</div>
    </div>

      {
        loading?(<><Loader/></>):(
    <form className="woocommerce-cart-form">
      <table className="cart_table">
        <thead>
          <tr>
            <th className="cart-col-image">Image</th>
            <th className="cart-col-productname">course  Name</th>
            <th className="cart-col-price">Price</th>
            <th className="cart-col-quantity">Quantity</th>
            <th className="cart-col-total">Total</th>
            <th className="cart-col-remove">Remove</th>
          </tr>
        </thead>
        <tbody>
           {
            cartloading ?  (<Loader/>) : (
              <>
             {
               databasecartdata.map((curcart , index)=>(
              <tr className="cart_item" key={index}>
             <td data-title="Product">
              <NavLink className="cart-productimage" to={`/course-detail/${curcart.slug}`} ><img width={91} height={91} src={`${BASE_URL}${curcart.course_img}`} alt="Image" /></NavLink>
            </td>
            <td data-title="Name">
              <NavLink className="cart-productname" to={`/course-detail/${curcart.slug}`}>{curcart.course_name}</NavLink>
            </td>
            <td data-title="Price">
              <span className="amount"><bdi><span></span>  <Formatprice price={curcart.course_price} /></bdi></span>
            </td>
       <td data-title="Quantity">
      <div className="quantity">
        <button className="quantity-minus qty-btn" type='button'
         onClick={()=>SetDecrease(curcart.id , curcart.quantity)}
         >
          <i className="far fa-minus" />
        </button>
        <h6 style={{color:"black", margin:".5rem"}}><strong>{curcart.quantity}</strong></h6>
             <button className="quantity-plus qty-btn" type='button' 
        onClick={()=>SetIncrease(curcart.id , curcart.quantity)}>
            <i className="far fa-plus" />
        </button>
      </div>

       {/* cart price  total  */}
         </td>
            <td data-title="Total">
              <span className="amount"><bdi><span></span><Formatprice price={curcart.total_price}/> </bdi></span>
            </td>

              {/* remove cart  */}

            <td data-title="Remove">
              <a className="remove"><i className="fal fa-trash-alt"
               onClick={()=>removeitem(curcart.id)} style={{cursor:"pointer"}} /></a>
            </td>
          </tr>
           ))}

          <tr>
            <td colSpan={6} className="actions">
              {/* <div className="th-cart-coupon">
                <input type="text" className="form-control" placeholder="Coupon Code..." />
                <button type="submit" className="th-btn">Apply Coupon</button>
              </div> */}

              {/* <button type="button" className="th-btn" onClick={()=>clearCart(User_id)}>Clear cart</button> */}

              <NavLink to="/course" className="th-btn">Continue Shopping</NavLink>
            </td>
          </tr>

          </> )}
        </tbody>
      </table>
    </form>
)}

    <div className="row justify-content-end">
      <div className="col-md-8 col-lg-7 col-xl-6">
        <h2 className="h4 summary-title">Cart Totals</h2>
        <table className="cart_totals">
          {/* <tbody>
            <tr>
              <td>Cart Subtotal</td>
              <td data-title="Cart Subtotal">
                <span className="amount"><bdi><span></span> <Formatprice price ={total_cart_price}/></bdi></span>
              </td>

            </tr>
            <tr className="shipping">
              <th>Shipping and Handling</th>
              <td data-title="Shipping and Handling">
                <ul className="woocommerce-shipping-methods list-unstyled">
                  <li>
                    <input type="radio" id="free_shipping" name="shipping_method" className="shipping_method" />
                    <label htmlFor="free_shipping">Free shipping</label>
                  </li>
                  <li>
                    <input type="radio" id="flat_rate" name="shipping_method" className="shipping_method" defaultChecked="checked" />
                    <label htmlFor="flat_rate">Flat rate</label>
                  </li>
                </ul>
                <p className="woocommerce-shipping-destination">
                  Shipping options will be updated during checkout.
                </p>
                <form action="" method="post">
                  <a  className="shipping-calculator-button">Change address</a>
                  <div className="shipping-calculator-form">
                    <p className="form-row">
                      <input type="text" className="form-control" placeholder="Town / City" />
                    </p>
                    <p className="form-row">
                      <input type="text" className="form-control" placeholder="Postcode / ZIP" />
                    </p>
                    <p>
                      <button className="th-btn">Update</button>
                    </p>
                  </div>
                </form>
              </td>
            </tr>
          </tbody> */}
          <tfoot>

            <tr className="order-total">
              <td>Order Total</td>
              <td data-title="Total">
                <strong><span className="amount"><bdi><span></span><Formatprice price={totalCartPrice ? totalCartPrice : 0}/> </bdi></span></strong>
              </td>
            </tr>
          </tfoot>
        </table>
        <div className="wc-proceed-to-checkout mb-30">
        <NavLink to="/checkout" className="th-btn">Proceed to checkout</NavLink>
        </div>
      </div>
    </div>
    </>)}
  </div>
</div>
    </>
  )
}

export default Cartpage
